import src from "IMAGE";
export default { src, width: 421, height: 121, blurWidth: 0, blurHeight: 0};
